import { useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';
import 'moment/locale/es';
//Views
import LoginView from 'Core/views/login';
import LoginSocialMediaView from 'Core/views/loginSocialMedia'
import ModulesRoutes from 'Modules';
import { NotificationContainer } from "Components/Notifications";
import ConfirmUserView from 'Core/views/confirmUser';
import ForgotPasswordView from 'Core/views/forgotPassword';
//Definitions
import locales from 'Locales';

//Styles
import './main.scss';

const Main = () => {
    const lang = useSelector(state => state.commonRedux.language);
    useEffect(() => {
        moment.locale(lang || 'en');
    }, [lang]);
    return (
        <IntlProvider locale={lang} messages={locales[lang]}>
            <NotificationContainer />
            <Routes>
                <Route path="/" element={<Navigate replace to="/app/accounts/list" />} />
                <Route path="/*" element={<ModulesRoutes to="/app" />} />
                <Route path="/login" element={<LoginView />} />
                <Route path={'/login-social-media'} element={<LoginSocialMediaView />} />
                <Route path="/confirmUser" element={<ConfirmUserView />} />
                <Route path="/forgotPassword" element={<ForgotPasswordView />} />
            </Routes>
        </IntlProvider>
    )
}
export default Main;